import script from "./ProductPending.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPending.vue?vue&type=script&setup=true&lang=ts"

import "./ProductPending.vue?vue&type=style&index=0&id=2a97033f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a97033f"]])

export default __exports__